import BaseIcon from './base-icon';

class PlusIcon extends BaseIcon {
  renderSVG(): string {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" stroke-width="2" viewBox="0 0 24 24" fill="none">
        <path d="M12 2V22" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M2 12H22" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    `;
  }
}

customElements.define('plus-icon', PlusIcon);
